/*
* @Author: babysoft08
* @Date:   2025-09-22 22:03:21
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-09-22 22:05:32
*/
import axios from 'axios';
import { API_URL } from '../../constants.js';

class NetPriceService {
	async shareNetpriceExcel(formData) {
		const url = `${API_URL}/share-netprice-excel/`;
		const headers = {
			'Content-Type':'multipart/form-data',
			'Access-Control-Allow-Origin':'*'
		}
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data: formData,
			config:{headers:headers},
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}
}

export default NetPriceService;